var map = {
	"./bianma.svg": "a37b",
	"./fanhui.svg": "c9c9",
	"./quickbi-xiaoq-query-mr.svg": "c7e0",
	"./quickbi-xiaoq-query-xz.svg": "6709",
	"./quickbi-xiaoq-report-mr.svg": "bc99",
	"./quickbi-xiaoq-report-xz.svg": "74be",
	"./quickbi-zizhuqushu-mr.svg": "efe4",
	"./quickbi-zizhuqushu-xz.svg": "bbad",
	"./shuaixuan.svg": "12fd",
	"./xinjian.svg": "7fc2",
	"./zuguanli.svg": "b9ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";